document.addEventListener('DOMContentLoaded', () => {
  const allTabWrappers = document.querySelectorAll(".faq-tab-wrapper");

  allTabWrappers.forEach(tabWrapper => {
    const tabBtns = tabWrapper.querySelectorAll("[data-tab-target]");
    const tabTargets = tabWrapper.querySelectorAll(".tab-target");

    tabWrapper.addEventListener("click", (e) => {
      const target = e.target.closest("[data-tab-target]");
      if (!target) return;

      e.preventDefault();

      const id = target.dataset.tabTarget;
      if (id) {
        tabBtns.forEach(btn => btn.classList.remove("is-active"));
        target.classList.add("is-active");

        tabTargets.forEach(content => content.classList.remove("is-active"));
        const targetContent = tabWrapper.querySelector(`#${id}`);
        if (targetContent) targetContent.classList.add("is-active");
      }

      // 👉 Nur Desktop: Pulse Glow für Tabs (ohne Shine)
      if (window.innerWidth >= 750) {
        target.classList.remove("pulse-glow");
        void target.offsetWidth; // reflow trick
        target.classList.add("pulse-glow");
      }
    });
  });
});

// Collapsible rechts
document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll(`.collapsible-trigger`);

  triggers.forEach(trigger => {
    const targetId = trigger.getAttribute('aria-controls');
    const content = document.getElementById(targetId);

    if (content) {
      content.style.height = '0px';

      trigger.addEventListener('click', () => {
        trigger.classList.toggle('is-open');
        content.classList.toggle('is-open');

        const isExpanded = trigger.classList.contains('is-open');
        trigger.setAttribute('aria-expanded', isExpanded);

        if (isExpanded) {
          content.style.height = 'auto';
          const fullHeight = content.scrollHeight + 'px';
          content.style.height = '0px';

          setTimeout(() => {
            content.style.height = fullHeight;
          }, 10);
        } else {
          content.style.height = '0px';
        }

        // 👉 Nur Desktop: sanfter Zoom beim Klick auf Collapsible
        if (window.innerWidth >= 750) {
          trigger.style.transition = "transform .25s ease";
          trigger.style.transform = "scale(1.02)";
          setTimeout(() => {
            trigger.style.transform = "scale(1)";
          }, 250);
        }
      });

      // Resize handling für offene Inhalte
      let resizeTimer;
      window.addEventListener('resize', () => {
        if (trigger.classList.contains('is-open')) {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            content.style.height = 'auto';
            const fullHeight = content.scrollHeight + 'px';
            content.style.height = fullHeight;
          }, 250);
        }
      });
    }
  });
});
